import { type InputHTMLAttributes, forwardRef } from 'react';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  error?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  function Input({ error = false, className = '', ...props }, ref) {
    return (
      <input
        ref={ref}
        className={`
          w-full rounded-lg border bg-white px-4 py-2 text-sm text-gray-900
          transition-colors
          placeholder:text-gray-500
          focus:outline-none focus:ring-2 focus:ring-accent/20
          disabled:cursor-not-allowed disabled:opacity-50
          dark:bg-gray-800 dark:text-white dark:placeholder:text-gray-400
          ${
            error
              ? 'border-red-500 focus:border-red-500'
              : 'border-gray-300 focus:border-accent dark:border-gray-600'
          }
          ${className}
        `}
        {...props}
      />
    );
  }
);
